setTimeout(() => {
  const content = document.querySelector('.anchor-main');
  const sidebarCurrent = document.querySelector('.anchor-aside__list-container');

  // Don't initialize scrollnav (which injects a list) when there
  // are no qualifying headings to populate it. An empty list container fails
  // the "Container element is empty" accessibility check.
  if (!content || !sidebarCurrent) return;
  if (content.querySelectorAll('h2').length === 0) return;

  scrollnav.init(content, {
    insertTarget: sidebarCurrent,
    insertLocation: 'append',
  });
}, '100');